import { NgIf, NgStyle } from '@angular/common';
import { Component, Injector, Input, OnInit } from '@angular/core';

import { TrackingService, UserService } from '@frontend/vanilla/core';

import { GamingStoriesApiService } from '../gaming-stories-api/gaming-stories-api.service';
import { InstagramStoryModalComponent } from '../instagram-story-modal/instagram-story-modal.component';
import { UserActionService } from '../shared/services/user-action.service';

@Component({
    selector: 'cc-promo-optin-button',
    templateUrl: 'promo-optin-button.component.html',
    imports: [NgIf, NgStyle],
})
export class PromoOptinButtonComponent implements OnInit {
    @Input() item: any;
    optInStatus: string;
    optInClickedStatus: string;
    optInButtonText: string;
    displayOptIn: boolean;
    promoOptinBtnClr: string;
    promoOptinBtnBgClr: string;
    optInDisabled: boolean;
    targetPromoId: string;
    targetPromoType: string;
    targetPromoStatus: string;
    displayError: boolean;
    errorMessage: string;
    activePromoIndex: number;
    activePromoStoryIndex: number;
    versionedList: any;
    activePromoName: string;
    activePromoStoryName: string;

    constructor(
        private gamingStoriesApiService: GamingStoriesApiService,
        private user: UserService,
        public injector: Injector,
        private userActionService: UserActionService,
        private tracking: TrackingService,
    ) {}

    ngOnInit() {
        this.setDataFromModalComponent();
    }

    setDataFromModalComponent() {
        const storyComponent = this.injector.get(InstagramStoryModalComponent);
        this.targetPromoId = storyComponent.targetPromoId;
        this.targetPromoType = storyComponent.targetPromoType;
        this.targetPromoStatus = storyComponent.targetPromoStatus;
        this.activePromoIndex = storyComponent.activePromoIndex;
        this.activePromoStoryIndex = storyComponent.activePromoStoryIndex;
        this.versionedList = storyComponent.versionedList;
        this.activePromoName = storyComponent.activePromo.promoItemId;
        this.activePromoStoryName = storyComponent.activePromo.instaStoryContentModel[this.activePromoStoryIndex].mainStoryItemName;
        if (this.targetPromoStatus) {
            this.setOptInButtonConfigurations(this.targetPromoStatus);
        }
    }

    optInClicked() {
        if (this.user.isAuthenticated) {
            this.promoOptinBtnClr = this.item.keys.promoAlreadyOptedinBtnClr;
            this.promoOptinBtnBgClr = this.item.keys.promoAlreadyOptedinBtnBgClr;
            this.optInDisabled = true;
            const params = {
                type: this.targetPromoType,
                id: this.targetPromoId,
                optIn: true,
                source: 'INBOX',
            };
            this.gamingStoriesApiService.get('/optinpromo/GetOptedPromo', params, { withCredentials: true }).subscribe(
                (response) => {
                    if (response) {
                        this.optInClickedStatus = response;
                        this.setOptInResponse(this.optInClickedStatus);
                        this.setOptInButtonConfigurations(this.optInClickedStatus);
                    }
                },
                (error) => {
                    this.setOptInResponseError(error);
                },
            );
            this.trackGamingStories();
        }
    }

    setOptInButtonConfigurations(status: string) {
        this.displayOptIn = true;
        if (status == 'OFFERED' || status == 'OPTED_OUT') {
            this.optInDisabled = false;
            this.optInButtonText = this.item.parameters.OptinBtn;
            this.promoOptinBtnClr = this.item.keys.promoOptinBtnClr;
            this.promoOptinBtnBgClr = this.item.keys.promoOptinBtnBgClr;
        } else if (status == 'OPTED_IN') {
            this.optInDisabled = true;
            this.optInButtonText = this.item.parameters.AlreadyOptedinBtn;
            this.promoOptinBtnClr = this.item.keys.promoAlreadyOptedinBtnClr;
            this.promoOptinBtnBgClr = this.item.keys.promoAlreadyOptedinBtnBgClr;
        }
    }

    setOptInResponse(status: string) {
        if (status == 'OPTED_IN') {
            const statusObj = {
                activePromoIndex: this.activePromoIndex,
                activePromoStoryIndex: this.activePromoStoryIndex,
                promoStatus: status,
            };
            this.userActionService.changePromoStatus(statusObj);
        }
    }

    setOptInResponseError(error: any) {
        this.promoOptinBtnClr = this.item.keys.promoOptinBtnClr;
        this.promoOptinBtnBgClr = this.item.keys.promoOptinBtnBgClr;
        this.optInDisabled = false;
        this.displayError = true;
        if (error.optedPromoStatus) {
            const errorKey = error.optedPromoStatus;
            this.errorMessage = this.versionedList[errorKey];
        } else {
            this.errorMessage = this.versionedList['TechnicalError'];
        }
    }

    trackGamingStories() {
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'click',
            'component.PositionEvent': this.activePromoName,
            'component.LocationEvent': this.activePromoStoryName,
            'component.EventDetails': 'opt-in cta',
            'component.URLClicked': 'not applicable',
        });
    }
}
